__turbopack_context__.v({
  "position_bottom": "styles-module-scss-module__cSTAOW__position_bottom",
  "position_left": "styles-module-scss-module__cSTAOW__position_left",
  "position_right": "styles-module-scss-module__cSTAOW__position_right",
  "position_top": "styles-module-scss-module__cSTAOW__position_top",
  "tooltip_container": "styles-module-scss-module__cSTAOW__tooltip_container",
  "tooltip_content": "styles-module-scss-module__cSTAOW__tooltip_content",
  "tooltip_trigger": "styles-module-scss-module__cSTAOW__tooltip_trigger",
  "visible": "styles-module-scss-module__cSTAOW__visible",
});
